import React, { useRef } from "react";
import { _ } from "libs";
import { resendPhoneVerificationCode, verifyPhoneVerificationCode, flash, flashError } from "../../actions";

type Props = {
	onVerify: () => void;
};

const PhoneNumberVerify = ({ onVerify }: Props) => {
	const input = useRef<HTMLInputElement>();

	const onClick = () => {
		const token = input.current.value;
		verifyPhoneVerificationCode(token)
			.then(onVerify)
			.catch(() => flashError(_("accountForm.verifyPhoneNumber.invalid")));
	};

	return (
		<div className="field">
			<input type="text" ref={input} />
			<div className="button xsmall green flat" onClick={onClick}>
				{_("verifyBtn")}
			</div>
			<div className="note">{_("accountForm.verifyPhoneNumber.note")}</div>
			<div className="mt-2">
				<span
					className="link blue"
					onClick={() => {
						resendPhoneVerificationCode();
						flash(_("accountForm.verifyPhoneNumber.codeSent"));
					}}
				>
					{_("accountForm.verifyPhoneNumber.resend")}
				</span>
			</div>
		</div>
	);
};

export default PhoneNumberVerify;
